import { render, staticRenderFns } from "./ProcessDocumentSign.vue?vue&type=template&id=02a53ccc&scoped=true"
import script from "./ProcessDocumentSign.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a53ccc",
  null
  
)

export default component.exports